import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-link-sides-warning-dialog',
  template: `
    <h2 mat-dialog-title i18n="@@Link Sides Warning">Link Sides Warning</h2>
    <mat-dialog-content>
      <p i18n="@@LinkSidesValuesDiffer">The Left and Right shift values are currently different.</p>
      <p i18n="@@LinkSidesApplyRight">If you continue, the Right side values will be applied to both sides.</p>
      <div class="shift-comparison">
        <div class="side-values">
          <strong i18n="@@Left">Left</strong>
          <span>V: {{data.leftVertical}} {{data.unitLabel}}</span>
          <span>H: {{data.leftHorizontal}} {{data.unitLabel}}</span>
        </div>
        <mat-icon style="align-self: center;">arrow_forward</mat-icon>
        <div class="side-values">
          <strong i18n="@@Right">Right</strong>
          <span>V: {{data.rightVertical}} {{data.unitLabel}}</span>
          <span>H: {{data.rightHorizontal}} {{data.unitLabel}}</span>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()" i18n="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel">Cancel</button>
      <button mat-raised-button color="primary" (click)="onConfirm()" i18n="@@Continue">Continue</button>
    </mat-dialog-actions>
  `,
  styles: [`
    .shift-comparison {
      display: flex;
      gap: 16px;
      align-items: flex-start;
      margin: 12px 0;
      padding: 12px;
      background: #f5f5f5;
      border-radius: 4px;
    }
    .side-values {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
  `]
})
export class LinkSidesWarningDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<LinkSidesWarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      leftVertical: number;
      leftHorizontal: number;
      rightVertical: number;
      rightHorizontal: number;
      unitLabel: string;
    }
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}

